module.exports = __webpack_public_path__ + "img/home_bg1.69f91834.png";